module.exports = __webpack_public_path__ + "img/xls-file-format-symbol.a57dd8d4.svg";